import { createVNode, render } from 'vue';
import DialogTemplate from '@/components/utils/actions/DialogTemplate.vue';
import { useDialogStore } from '@/stores/dialog';

const dialogKey = Symbol('dialog');

const dialogPlugin = {
    install: (app) => {
        const dialogStore = useDialogStore();
        app.config.globalProperties.$dialog = {
            create: dialogStore.create,
            confirm: dialogStore.confirm,
        };

        // Provide the dialog functions using app.provide for composition API usage
        app.provide(dialogKey, {
            create: dialogStore.create,
            confirm: dialogStore.confirm,
        });

        // Create and render the DialogTemplate component
        const dialog = createVNode(DialogTemplate);
        dialog.appContext = app._context;
        render(dialog, document.body);
    },
};

export { dialogKey };
export default dialogPlugin;
